import { Request } from 'commons/utils/request'

import { BankKeySetupResponse, BioTrackFormPayload, DutchieFormPayload, MetrcFormPayload } from './types'

export const postMetrc = (payload: MetrcFormPayload) =>
  Request.post<BankKeySetupResponse, MetrcFormPayload>(Request.urls.bank.connectionsMetrcCredentials, payload)

export const postMetrcTest = async (): Promise<BankKeySetupResponse> =>
  Promise.resolve({
    message: 'Any message from Metrc',
    passedValidation: [
      {
        licenseId: 123,
        licenseNumber: '123 lic number',
        licenseName: '123 lic name',
        companyName: 'Company name 123'
      },
      {
        licenseId: 333,
        licenseNumber: '333 lic number',
        licenseName: '333 lic name',
        companyName: 'Company name 333'
      }
    ],
    failedValidation: [
      {
        licenseId: 666,
        licenseNumber: 'Failed 666 lic number',
        licenseName: 'Failed 666 lic name',
        companyName: 'Failed licenses company name',
        message: 'Failed to add this license to Metrc',
        retryable: true
      }
    ]
  })

export const postBioTrack = (payload: BioTrackFormPayload) =>
  Request.post(Request.urls.bank.connectionsBioTrackCredentials, payload)

export const postDutchie = (payload: DutchieFormPayload) =>
  Request.post(Request.urls.bank.connectionsDutchieCredentials, payload)
